import React, { useState, useEffect } from "react";
import axios from "axios";
import uuid from "react-uuid";

export const ViewStatement = () => {
  const [statements, setStatements] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [acno, setAcno] = useState("");
  const [acc, setAcc] = useState([]);
  const [showResults, setShowResults] = useState(false);

  useEffect(() => {
    getDetails();
  }, []);
  const getDetails = async () => {
    const res = await axios.get("http://localhost:5001/accounts");
    setAcno(res.data[0].account_number);
    setAcc(res.data);
  };
  const handleClick = () => {
    let data = {
      from: fromDate,
      to: toDate,
      acc: acno,
    };
    axios
      .post("http://localhost:5001/statement", {
        data: data,
      })
      .then((res) => {
        setStatements(res.data);
        setShowResults(true);
      })
      .catch((err) => {
        setShowResults(true);
        setStatements([]);
      });
  };

  // Helper to determine credit/debit
  const isCredit = (desc = "") =>
    desc.toLowerCase().includes("received") || desc.toLowerCase().includes("credit");

  return (
    <div className="main-data">
      <div className="statement-card">
        <h2>Transaction History</h2>
        <div className="trans-input modern-filter">
          <div className="form-group">
            <label htmlFor="acc">Account</label>
            <select
              name="accounts"
              id="acc"
              onChange={(e) => setAcno(e.target.value)}
              value={acno}
            >
              <option value="default">-- select account --</option>
              {acc.map((acn) => (
                <option key={uuid()} value={acn.account_number}>
                  {acn.account_number}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="from-date">From</label>
            <input
              type={fromDate ? "date" : "text"}
              placeholder="From Date"
              name="from-date"
              id="from-date"
              onFocus={(e) => (e.target.type = "date")}
              onChange={(e) => {
                setFromDate(e.target.value);
              }}
              value={fromDate}
            />
          </div>
          <div className="form-group">
            <label htmlFor="to-date">To</label>
            <input
              type={toDate ? "date" : "text"}
              name="to-date"
              placeholder="To Date"
              id="to-date"
              value={toDate}
              onFocus={(e) => (e.target.type = "date")}
              onChange={(e) => {
                setToDate(e.target.value);
              }}
            />
          </div>
          <button className="subButton" onClick={handleClick}>
            Search
          </button>
        </div>
        {showResults && (
          <div className="statement-result">
            {statements.length === 0 ? (
              <div className="empty-state">
                <p>No transactions found for the selected period.</p>
              </div>
            ) : (
              <table className="transactions-table">
                <thead>
                  <tr>
                    <th>Txn ID</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Amount</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {statements.map((stmt, i) => (
                    <tr
                      key={i}
                      className={isCredit(stmt.description) ? "credit-row" : "debit-row"}
                    >
                      <td>{stmt.transaction_id}</td>
                      <td>{stmt.date.slice(0, 10)}</td>
                      <td>{stmt.time}</td>
                      <td className="amount-cell">
                        <span className={isCredit(stmt.description) ? "credit-amount" : "debit-amount"}>
                          {isCredit(stmt.description) ? "+" : "-"}₹{stmt.amount}
                        </span>
                      </td>
                      <td>{stmt.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewStatement;
